import { createSelector } from "@reduxjs/toolkit";

import { getPageFsVars } from "@store/share-dialog/selectors";
import { getIntegrationVars } from "../get-integration-vars";

export const getPageAndIntegrationVars = createSelector(
  getPageFsVars,
  getIntegrationVars,
  (pageFsVars, integrationVars = []) => {
    return [...pageFsVars, ...integrationVars];
  },
);

export const hasVariables = createSelector(
  getPageAndIntegrationVars,
  (vars) => {
    return vars.length > 0;
  },
);
